module.exports = __webpack_public_path__ + "img/vib.417ff242.svg";